export default function Footer() {
  return (
    <footer className="bg-slate-800 text-slate-300 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/eb02e9f867d09d1d36fd0cf7eb13e846.jpeg"
              alt="Evrensel Temizlik Hizmetleri"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              18 yıllık tecrübemizle İstanbul Anadolu Yakası, Yalova, Karamürsel, Kocaeli ve İzmit&#39;te ev, araç ve kurumsal temizlik hizmeti sunuyoruz.
            </p>
            <div className="flex gap-3 mt-4 flex-wrap">
              <a href="tel:05055600419" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors whitespace-nowrap">
                <i className="ri-phone-fill text-sky-400" />
                0505 560 04 19
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h5 className="text-white font-semibold mb-4 text-sm">Hizmetlerimiz</h5>
            <ul className="flex flex-col gap-2 text-sm">
              {['Koltuk Yıkama', 'Araç Temizliği', 'Petek Temizliği', 'Yatak Yıkama', 'Halı Yıkama', 'İnşaat Sonrası Temizlik'].map((s) => (
                <li key={s}>
                  <a href="#hizmetler" className="text-slate-400 hover:text-white transition-colors flex items-center gap-1.5">
                    <i className="ri-arrow-right-s-line text-sky-500" />
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-white font-semibold mb-4 text-sm">Hızlı Bağlantılar</h5>
            <ul className="flex flex-col gap-2 text-sm">
              {[
                { label: 'Hizmetler', href: '#hizmetler' },
                { label: 'Neden Biz?', href: '#neden-biz' },
                { label: 'SSS', href: '#sss' },
                { label: 'İletişim', href: '#iletisim' },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-slate-400 hover:text-white transition-colors flex items-center gap-1.5">
                    <i className="ri-arrow-right-s-line text-sky-500" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <a
                href="https://wa.me/905055600419?text=Merhaba%2C%20temizlik%20hizmeti%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold px-4 py-2.5 rounded-full transition-all whitespace-nowrap"
              >
                <i className="ri-whatsapp-line" />
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>&copy; 2026 Evrensel Temizlik Hizmetleri. Tüm hakları saklıdır.</p>
          <p className="flex items-center gap-1">
            <i className="ri-map-pin-2-line text-sky-500" />
            İstanbul Anadolu Yakası • Yalova • Karamürsel • Kocaeli • İzmit
          </p>
        </div>
      </div>
    </footer>
  );
}
